// When the gateway's crypto session lapses (or the user's IP changes) in the middle of someone's work, the app asks for the
// MPIN in a modal OVER the page they are on, then repeats the call that failed - so nothing they were doing is lost.
// This is the hand-over between gatewayAxios (which hits the problem, possibly in many calls at once) and the modal
// (which asks). Everyone who asks while the modal is open shares it.

let listener = null;   // the modal, once mounted
let pending = null;    // { promise, resolve, reject }

export function setUnlockListener(fn) {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}

export function hasUnlockListener() {
  return !!listener;
}

/**
 * Resolves once the user has proved their MPIN, rejects if they gave up (logged out). `prepare` runs ONCE, before the
 * modal opens (the new crypto session), however many calls ask.
 */
export function requestUnlock(mode, prepare) {
  if (pending) return pending.promise;
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  pending = { promise, resolve, reject };
  Promise.resolve()
    .then(() => (prepare ? prepare() : undefined))
    .catch(() => { /* the modal's own MPIN call shakes hands again if it has to */ })
    .then(() => {
      if (pending && listener) listener({ mode });
      else unlockCancelled(new Error("No unlock screen is mounted"));
    });
  return promise;
}

export function unlockDone() {
  const p = pending;
  pending = null;
  if (p) p.resolve();
}

export function unlockCancelled(reason) {
  const p = pending;
  pending = null;
  if (p) p.reject(reason || new Error("MPIN unlock cancelled"));
}
